import axios from 'axios';
import JSEncrypt from 'jsencrypt';

const isDev = process.env.NODE_ENV === 'development';
const localUrl = 'https://api.dev.mvpick.net/api';
const API_BASE_URL = isDev ? localUrl : (process.env.REACT_APP_API_BASE_URL || '/api');

let cachedPublicKey: string | null = null;
let pendingPublicKey: Promise<string> | null = null;

const normalizePublicKey = (value: unknown) => {
  if (typeof value !== 'string') return '';
  return value.replace(/\\n/g, '\n').trim();
};

export const fetchPublicKey = async (): Promise<string> => {
  if (cachedPublicKey) return cachedPublicKey;
  if (pendingPublicKey) return pendingPublicKey;
  pendingPublicKey = axios
    .get(`${API_BASE_URL}/public/crypto/public-key`)
    .then((res) => {
      const raw = res?.data?.data?.publicKey ?? res?.data?.publicKey ?? res?.data;
      const normalized = normalizePublicKey(raw);
      if (!normalized) {
        throw new Error('public key missing');
      }
      cachedPublicKey = normalized;
      return normalized;
    })
    .finally(() => {
      pendingPublicKey = null;
    });
  return pendingPublicKey;
};

export const encryptLoginPayload = async (loginId: string, password: string) => {
  const publicKey = await fetchPublicKey();
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  const encryptedLoginId = encryptor.encrypt(String(loginId));
  const encryptedPassword = encryptor.encrypt(String(password));
  if (!encryptedLoginId || !encryptedPassword) {
    throw new Error('RSA encryption failed');
  }
  return { encryptedLoginId, encryptedPassword };
};
